// import React, { useState, useEffect, useRef } from "react";
// import api from '../../chat/api';
// import { getFreshAccessToken } from "../../chat/api";

// const UploadFolderModal = ({
//   isOpen,
//   onClose,
//   filesToUpload,
//   folderId,
//   onUploadSuccess,
// }) => {
//   const [files, setFiles] = useState([]);
//   const [uploading, setUploading] = useState(false);
//   const [uploadSuccess, setUploadSuccess] = useState(false);
//   const [uploadErrors, setUploadErrors] = useState([]);
//   const [selectedTags, setSelectedTags] = useState([]);
//   const selectedTagsRef = useRef([]);

//   // Status enum for better state management
//   const STATUS = { 
//     PENDING: 'pending', 
//     UPLOADING: 'uploading', 
//     SUCCESS: 'success', 
//     ERROR: 'error' 
//   };

//   useEffect(() => {
//     selectedTagsRef.current = selectedTags;
//   }, [selectedTags]);

//   useEffect(() => {
//     if (isOpen && filesToUpload.length > 0) {
//       handleUpload();
//     }
//   }, [isOpen, filesToUpload]);

//   const handleUpload = async () => {
//     if (filesToUpload.length === 0) return;

//     setUploading(true);
//     setUploadSuccess(false);
//     setUploadErrors([]);

//     // Initialize files state
//     const initialFiles = filesToUpload.map((file) => ({
//       file,
//       progress: 0,
//       status: STATUS.PENDING,
//       key: null,
//       ws: null,
//       file_id: null,
//       errorReason: null,
//     }));
//     setFiles(initialFiles);

//     // Start batch upload with WebSocket
//     await startBatchUpload(initialFiles);
//   };

//   const startBatchUpload = async (fileList) => {
//     const formData = new FormData();
//     fileList.forEach(f => formData.append("files", f.file));

//     const token = await getFreshAccessToken();
//     const url = `api/v1/readpdf/upload-in-folder/${folderId}/`;

//     // Create WebSocket connection for real-time updates
//     const ws = new WebSocket(
//       `${process.env.REACT_APP_WS_URL}/ws/upload-status/?token=${token}`
//     );

//     ws.onmessage = (e) => {
//       const data = JSON.parse(e.data);

//       setFiles(prevFiles => {
//         let alreadyClaimed = false;

//         const updatedFiles = prevFiles.map((f, i) => {
//           const isKeyMatch = f.key === data.pdf_key;

//           const canClaim =
//             !alreadyClaimed &&
//             !f.key &&
//             f.status === STATUS.UPLOADING &&
//             data.pdf_key &&
//             !prevFiles.some((other, idx) => other.key === data.pdf_key && idx !== i);

//           if (!isKeyMatch && !canClaim) return f;

//           const patch = {};

//           if (canClaim) {
//             patch.key = data.pdf_key;
//             alreadyClaimed = true;
//           }

//           if (data.type === "progress") {
//             patch.progress = data.progress;
//           } else if (data.type === "completed") {
//             // Skip update if metadata is null (first completed message)
//             if (!data.metadata?.file_id) {
//               console.warn("⚠️ [FolderUpload] Skipping early completed message without metadata:", data);
//               return f;
//             }

//             patch.status = STATUS.SUCCESS;
//             patch.progress = 100;
//             patch.file_id = data.metadata.file_id;
//           } else if (data.type === "error") {
//             patch.status = STATUS.ERROR;
//             patch.progress = 0;
//             const msg = data.message?.toLowerCase() || "";

//             if (msg.includes("unsupported")) {
//               patch.errorReason = "unsupported";
//             } else if (msg.includes("duplicate")) {
//               patch.errorReason = "duplicate";
//             } else if (msg.includes("size") || msg.includes("limit")) {
//               patch.errorReason = "size_limit";
//             } else {
//               patch.errorReason = "unknown";
//             }
//           }

//           return { ...f, ...patch };
//         });

//         // Close WebSocket when all files are done
//         const allDone = updatedFiles.every(
//           f => f.status === STATUS.SUCCESS || f.status === STATUS.ERROR
//         );
        
//         if (allDone && ws.readyState === WebSocket.OPEN) {
//           ws.close();
//         }

//         return updatedFiles;
//       });
//     };

//     ws.onerror = (error) => {
//       console.error("WebSocket error:", error);
//       // Mark all files as error if WebSocket fails
//       setFiles(prev => prev.map(f => ({ 
//         ...f, 
//         status: STATUS.ERROR,
//         errorReason: "websocket_error"
//       })));
//     };

//     try {
//       // Update files to uploading status
//       setFiles(prev => prev.map(f => 
//         fileList.some(newFile => newFile.file.name === f.file.name) 
//           ? { ...f, status: STATUS.UPLOADING } 
//           : f
//       ));

//       // Start HTTP upload
//       const response = await api.post(url, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//         onUploadProgress: (progressEvent) => {
//           if (progressEvent.total) {
//             const baseProgress = Math.min(30, Math.round((progressEvent.loaded * 100) / progressEvent.total));
//             setFiles(prev => prev.map(f => {
//               return { ...f, progress: Math.max(f.progress, baseProgress) };
//             }));
//           }
//         },
//       });

//       // Process upload response
//       const uploads = response.data?.uploads || [];
//       setFiles(prevFiles =>
//         prevFiles.map(f => {
//           const upload = uploads.find(u => u.filename === f.file.name);
//           return upload && upload.pdf_key
//             ? { ...f, key: upload.pdf_key }
//             : f;
//         })
//       );

//     } catch (error) {
//       console.error("🚨 Batch upload failed:", error);
      
//       const statusCode = error?.response?.status;
//       const errorMessage = error?.response?.data?.error || "An unknown error occurred.";

//       if ((statusCode === 400 || statusCode === 403) &&
//           (errorMessage.includes("Trial users can upload") || errorMessage.includes("You have reached your upload limit"))) {
//         setUploadErrors([{ file: "Upload limit", error: errorMessage }]);
//       } else {
//         setFiles(prev => prev.map(f => ({ 
//           ...f, 
//           status: STATUS.ERROR,
//           errorReason: "upload_failed"
//         })));
//       }

//       // Close WebSocket on error
//       if (ws.readyState === WebSocket.OPEN) {
//         ws.close();
//       }
//     }
//   };

//   const handleClose = async () => {
//     // Tag successful uploads if tags are selected
//     if (selectedTagsRef.current.length > 0) {
//       try {
//         const token = await getFreshAccessToken();
//         const taggedDocs = files.filter(f => f.status === STATUS.SUCCESS && f.file_id);

//         for (const tag of selectedTagsRef.current) {
//           for (const file of taggedDocs) {
//             await api.post(
//               `api/tagging/tagged-items/`,
//               {
//                 tag_id: tag.id,
//                 pdf_document_id: file.file_id,
//                 folder_id: folderId,
//               }
//             );
//           }
//         }
//       } catch (err) {
//         console.error("❌ Tagging failed:", err);
//       }
//     }

//     // Notify parent component
//     if (typeof onUploadSuccess === "function") {
//       onUploadSuccess();
//     }

//     // Reset state and close modal
//     setFiles([]);
//     setUploading(false);
//     setUploadSuccess(false);
//     setUploadErrors([]);
//     setSelectedTags([]);

//     onClose();
//   };

//   const handleAddMore = () => {
//     handleClose();
//     const fileInput = document.getElementById("fileInput");
//     if (fileInput) {
//       fileInput.click();
//     }
//   };

//   // Check if all uploads are completed
//   const allUploadsComplete = files.length > 0 && files.every(
//     f => f.status === STATUS.SUCCESS || f.status === STATUS.ERROR
//   );

//   // Calculate success and error counts
//   const successfulUploads = files.filter(f => f.status === STATUS.SUCCESS).length;
//   const failedUploads = files.filter(f => f.status === STATUS.ERROR).length;

//   // Set upload success when all complete and at least one success
//   useEffect(() => {
//     if (allUploadsComplete && successfulUploads > 0) {
//       setUploadSuccess(true);
//       setUploading(false);
//     } else if (allUploadsComplete) {
//       setUploading(false);
//     }
//   }, [allUploadsComplete, successfulUploads]);

//   const CloseIcon = () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//     </svg>
//   );

//   const CheckIcon = () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#22C55E"/>
//     </svg>
//   );

//   const ErrorIcon = () => (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#EF4444"/>
//     </svg>
//   );
//   const PlusIcon = () => (
//     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path 
//         d="M10 4.16669V15.8334M4.16669 10H15.8334" 
//         stroke="#C95EBE" 
//         strokeWidth="1.5" 
//         strokeLinecap="round" 
//         strokeLinejoin="round"
//       />
//     </svg>
//   );

//   if (!isOpen) return null;

//   const fileCount = filesToUpload.length;
//   const pluralS = fileCount > 1 ? "s" : "";

//   return (
//     <div className="fixed inset-0 z-50 flex font-outfit items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm">
//       <div className="relative w-full max-w-md p-6 bg-white rounded-lg shadow-xl mx-4">
//         <button
//           onClick={handleClose}
//           className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
//           aria-label="Close"
//         >
//           <CloseIcon />
//         </button>

//         {/* Header */}
//         <div className="pr-8">
//           <h2 className="text-xl font-semibold text-gray-800">
//             Uploading your Documents
//           </h2>
         
//         </div>

//         {/* Error Messages */}
//         {uploadErrors.length > 0 && (
//           <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
//             <p className="text-sm font-medium text-red-800 mb-2">
//               Some files failed to upload:
//             </p>
//             <ul className="text-sm text-red-700 list-disc list-inside space-y-1">
//               {uploadErrors.map((error, index) => (
//                 <li key={index}>
//                   <strong>{error.file}:</strong> {error.error}
//                 </li>
//               ))}
//             </ul>
//           </div>
//         )}

//         {/* Scrollable File List with Progress Bars */}
//         <div className="mt-6 max-h-[200px] overflow-y-auto pr-2 space-y-4">
//           {files.map((file, index) => (
//             <div key={index} className="flex-shrink-0">
//               {/* File name and progress/status */}
//               <div className="flex items-center justify-between gap-3">
//                 <div className="flex min-w-0 flex-1 items-center gap-3">
//                   <div className="flex-shrink-0">
//                     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//                       <mask id="mask0_775_15693" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
//                         <rect width="20" height="20" fill="#D9D9D9"/>
//                       </mask>
//                       <g mask="url(#mask0_775_15693)">
//                         <path d="M7.5026 10.8307H12.5026C12.7387 10.8307 12.9366 10.7509 13.0964 10.5911C13.2561 10.4314 13.3359 10.2335 13.3359 9.9974C13.3359 9.76128 13.2561 9.56337 13.0964 9.40365C12.9366 9.24392 12.7387 9.16406 12.5026 9.16406H7.5026C7.26649 9.16406 7.06858 9.24392 6.90885 9.40365C6.74913 9.56337 6.66927 9.76128 6.66927 9.9974C6.66927 10.2335 6.74913 10.4314 6.90885 10.5911C7.06858 10.7509 7.26649 10.8307 7.5026 10.8307ZM7.5026 13.3307H12.5026C12.7387 13.3307 12.9366 13.2509 13.0964 13.0911C13.2561 12.9314 13.3359 12.7335 13.3359 12.4974C13.3359 12.2613 13.2561 12.0634 13.0964 11.9036C12.9366 11.7439 12.7387 11.6641 12.5026 11.6641H7.5026C7.26649 11.6641 7.06858 11.7439 6.90885 11.9036C6.74913 12.0634 6.66927 12.2613 6.66927 12.4974C6.66927 12.7335 6.74913 12.9314 6.90885 13.0911C7.06858 13.2509 7.26649 13.3307 7.5026 13.3307ZM7.5026 15.8307H10.0026C10.2387 15.8307 10.4366 15.7509 10.5964 15.5911C10.7561 15.4314 10.8359 15.2335 10.8359 14.9974C10.8359 14.7613 10.7561 14.5634 10.5964 14.4036C10.4366 14.2439 10.2387 14.1641 10.0026 14.1641H7.5026C7.26649 14.1641 7.06858 14.2439 6.90885 14.4036C6.74913 14.5634 6.66927 14.7613 6.66927 14.9974C6.66927 15.2335 6.74913 15.4314 6.90885 15.5911C7.06858 15.7509 7.26649 15.8307 7.5026 15.8307ZM5.0026 18.3307C4.54427 18.3307 4.15191 18.1675 3.82552 17.8411C3.49913 17.5148 3.33594 17.1224 3.33594 16.6641V3.33073C3.33594 2.8724 3.49913 2.48003 3.82552 2.15365C4.15191 1.82726 4.54427 1.66406 5.0026 1.66406H10.9818C11.204 1.66406 11.4158 1.70573 11.6172 1.78906C11.8186 1.8724 11.9957 1.99045 12.1484 2.14323L16.1901 6.1849C16.3429 6.33767 16.4609 6.51476 16.5443 6.71615C16.6276 6.91753 16.6693 7.12934 16.6693 7.35156V16.6641C16.6693 17.1224 16.5061 17.5148 16.1797 17.8411C15.8533 18.1675 15.4609 18.3307 15.0026 18.3307H5.0026ZM15.0026 7.4974H12.0859C11.7387 7.4974 11.4436 7.37587 11.2005 7.13281C10.9575 6.88976 10.8359 6.59462 10.8359 6.2474V3.33073H5.0026V16.6641H15.0026V7.4974Z" fill="#73607B"/>
//                       </g>
//                     </svg>
//                   </div>
//                   <span className="truncate text-sm font-medium !text-[#171717]">
//                     {file.file.name.length > 25
//                       ? `${file.file.name.slice(0, 20)}...${file.file.name.slice(-10)}`
//                       : file.file.name}
//                   </span>
//                 </div>
//                 <div className="flex-shrink-0">
//                   {file.status === STATUS.SUCCESS ? (
//                     <CheckIcon />
//                   ) : file.status === STATUS.ERROR ? (
//                     <ErrorIcon />
//                   ) : (
//                     <span className="text-sm font-semibold text-gray-800">
//                       {Math.round(file.progress)}%
//                     </span>
//                   )}
//                 </div>
//               </div>
              
//               {/* Progress bar */}
//               <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-gray-200">
//                 <div
//                   className={`h-2 rounded-full transition-all duration-300 ease-linear ${
//                     file.status === STATUS.ERROR 
//                       ? "bg-red-500" 
//                       : file.status === STATUS.SUCCESS 
//                       ? "bg-green-500"
//                       : "bg-purple-600"
//                   }`}
//                   style={{
//                     width: `${file.progress}%`,
//                     background: file.status === STATUS.UPLOADING 
//                       ? "linear-gradient(180deg, #C95EBE 0%, #8B55DD 100%)"
//                       : undefined,
//                   }}
//                 ></div>
//               </div>
              
//               {file.status === STATUS.ERROR && (
//                 <p className="mt-1 text-xs text-red-600">
//                   {file.errorReason === "unsupported"
//                     ? "Unsupported file type"
//                     : file.errorReason === "duplicate"
//                     ? "Duplicate file"
//                     : file.errorReason === "size_limit"
//                     ? "File size exceeds limit"
//                     : "Upload failed"}
//                 </p>
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Footer */}
//         {(uploadSuccess || failedUploads > 0) && (
//           <div className="mt-6 space-y-3">
//             <button
//               onClick={handleAddMore}
//               className="flex items-center text-[#C95EBE] justify-center w-[30%] px-2 py-2 border !border-black/10 rounded-lg text-sm font-medium  "
//             >
//               <PlusIcon />
//               <span className="ml-2 text-[#C95EBE]">Add More</span>
//             </button>
//           </div>
//         )}

//         <div className="mt-6">
//           {uploadSuccess || failedUploads > 0 ? (
//             <div className="flex justify-end">
//               <button
//                 onClick={handleClose}
//                 className="px-6 py-2.5 bg-[#C95EBE] !text-white rounded-lg font-semibold text-sm "
//               >
//                 Done
//               </button>
//             </div>
//           ) : (
//             <div className="flex justify-between text-xs text-[#71717A]">
//               <span>Supported formats: PDF, TXT, CSV, XLS, DOCX, XLSX, JPG, JPEG, PNG</span>
//               <span>Maximum Size : 25MB</span>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UploadFolderModal;
import React, { useState, useEffect, useRef } from "react";
import api from '../../chat/api';
import { getFreshAccessToken } from "../../chat/api";

const UploadModal = ({
  isOpen,
  onClose,
  filesToUpload,
  folderId,
  onUploadSuccess,
  // New props for customization
  modalTitle = "Uploading your Documents",
  showAddMoreButton = true,
  showSupportedFormats = true,
  maxFileSize = "25MB",
  supportedFormats = "PDF, TXT, CSV, XLS, DOCX, XLSX, JPG, JPEG, PNG",
  uploadEndpoint = ``,
  wsEndpoint = `/ws/upload-status/`,
  // Custom styling props
  modalClassName = "",
  contentClassName = "",
  progressBarColor = "linear-gradient(180deg, #C95EBE 0%, #8B55DD 100%)",
  successColor = "#22C55E",
  errorColor = "#EF4444",
  uploadColor = "#C95EBE",
  // Custom icons (can be React components or SVG strings)
  CloseIcon = null,
  CheckIcon = null,
  ErrorIcon = null,
  PlusIcon = null,
  FileIcon = null,
  // Callbacks for custom behavior
  onFileUploadStart = null,
  onFileUploadComplete = null,
  onFileUploadError = null,
  // Additional metadata for tagging or other purposes
  additionalMetadata = {},
  // Tags functionality
  enableTags = false,
  onTagSuccess = null,
}) => {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadErrors, setUploadErrors] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const selectedTagsRef = useRef([]);

  // Status enum for better state management
  const STATUS = { 
    PENDING: 'pending', 
    UPLOADING: 'uploading', 
    SUCCESS: 'success', 
    ERROR: 'error' 
  };

  useEffect(() => {
    selectedTagsRef.current = selectedTags;
  }, [selectedTags]);

  useEffect(() => {
    if (isOpen && filesToUpload.length > 0) {
      handleUpload();
    }
  }, [isOpen, filesToUpload]);

  const handleUpload = async () => {
    if (filesToUpload.length === 0) return;

    setUploading(true);
    setUploadSuccess(false);
    setUploadErrors([]);

    // Call custom callback if provided
    if (onFileUploadStart) {
      onFileUploadStart(filesToUpload);
    }

    // Initialize files state
    const initialFiles = filesToUpload.map((file) => ({
      file,
      progress: 0,
      status: STATUS.PENDING,
      key: null,
      ws: null,
      file_id: null,
      errorReason: null,
    }));
    setFiles(initialFiles);

    // Start batch upload with WebSocket
    await startBatchUpload(initialFiles);
  };

  const startBatchUpload = async (fileList) => {
    const formData = new FormData();
    fileList.forEach(f => formData.append("files", f.file));

    // Add additional metadata if provided
    if (Object.keys(additionalMetadata).length > 0) {
      Object.entries(additionalMetadata).forEach(([key, value]) => {
        formData.append(key, value);
      });
    }

    const token = await getFreshAccessToken();
    const url = uploadEndpoint;

    // Create WebSocket connection for real-time updates
    const ws = new WebSocket(
      `${process.env.REACT_APP_WS_URL}${wsEndpoint}?token=${token}`
    );

    ws.onmessage = (e) => {
      const data = JSON.parse(e.data);

      setFiles(prevFiles => {
        let alreadyClaimed = false;

        const updatedFiles = prevFiles.map((f, i) => {
          const isKeyMatch = f.key === data.pdf_key;

          const canClaim =
            !alreadyClaimed &&
            !f.key &&
            f.status === STATUS.UPLOADING &&
            data.pdf_key &&
            !prevFiles.some((other, idx) => other.key === data.pdf_key && idx !== i);

          if (!isKeyMatch && !canClaim) return f;

          const patch = {};

          if (canClaim) {
            patch.key = data.pdf_key;
            alreadyClaimed = true;
          }

          if (data.type === "progress") {
            patch.progress = data.progress;
          } else if (data.type === "completed") {
            // Skip update if metadata is null (first completed message)
            if (!data.metadata?.file_id) {
              console.warn("⚠️ [UploadModal] Skipping early completed message without metadata:", data);
              return f;
            }

            patch.status = STATUS.SUCCESS;
            patch.progress = 100;
            patch.file_id = data.metadata.file_id;
            
            // Call custom callback on success
            if (onFileUploadComplete) {
              onFileUploadComplete(f.file, data.metadata);
            }
          } else if (data.type === "error") {
            patch.status = STATUS.ERROR;
            patch.progress = 0;
            const msg = data.message?.toLowerCase() || "";

            if (msg.includes("unsupported")) {
              patch.errorReason = "unsupported";
            } else if (msg.includes("duplicate")) {
              patch.errorReason = "duplicate";
            } else if (msg.includes("size") || msg.includes("limit")) {
              patch.errorReason = "size_limit";
            } else {
              patch.errorReason = "unknown";
            }
            
            // Call custom callback on error
            if (onFileUploadError) {
              onFileUploadError(f.file, data.message);
            }
          }

          return { ...f, ...patch };
        });

        // Close WebSocket when all files are done
        const allDone = updatedFiles.every(
          f => f.status === STATUS.SUCCESS || f.status === STATUS.ERROR
        );
        
        if (allDone && ws.readyState === WebSocket.OPEN) {
          ws.close();
        }

        return updatedFiles;
      });
    };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
      // Mark all files as error if WebSocket fails
      setFiles(prev => prev.map(f => ({ 
        ...f, 
        status: STATUS.ERROR,
        errorReason: "websocket_error"
      })));
    };

    try {
      // Update files to uploading status
      setFiles(prev => prev.map(f => 
        fileList.some(newFile => newFile.file.name === f.file.name) 
          ? { ...f, status: STATUS.UPLOADING } 
          : f
      ));

      // Start HTTP upload
      const response = await api.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const baseProgress = Math.min(30, Math.round((progressEvent.loaded * 100) / progressEvent.total));
            setFiles(prev => prev.map(f => {
              return { ...f, progress: Math.max(f.progress, baseProgress) };
            }));
          }
        },
      });

      // Process upload response
      const uploads = response.data?.uploads || [];
      setFiles(prevFiles =>
        prevFiles.map(f => {
          const upload = uploads.find(u => u.filename === f.file.name);
          return upload && upload.pdf_key
            ? { ...f, key: upload.pdf_key }
            : f;
        })
      );

    } catch (error) {
      console.error("🚨 Batch upload failed:", error);
      
      const statusCode = error?.response?.status;
      const errorMessage = error?.response?.data?.error || "An unknown error occurred.";

      if ((statusCode === 400 || statusCode === 403) &&
          (errorMessage.includes("Trial users can upload") || errorMessage.includes("You have reached your upload limit"))) {
        setUploadErrors([{ file: "Upload limit", error: errorMessage }]);
      } else {
        setFiles(prev => prev.map(f => ({ 
          ...f, 
          status: STATUS.ERROR,
          errorReason: "upload_failed"
        })));
      }

      // Close WebSocket on error
      if (ws.readyState === WebSocket.OPEN) {
        ws.close();
      }
    }
  };

  const handleClose = async () => {
    // Tag successful uploads if tags are selected and enabled
    if (enableTags && selectedTagsRef.current.length > 0) {
      try {
        const token = await getFreshAccessToken();
        const taggedDocs = files.filter(f => f.status === STATUS.SUCCESS && f.file_id);

        for (const tag of selectedTagsRef.current) {
          for (const file of taggedDocs) {
            await api.post(
              `api/tagging/tagged-items/`,
              {
                tag_id: tag.id,
                pdf_document_id: file.file_id,
                folder_id: folderId,
              }
            );
          }
        }
        
        // Call tag success callback if provided
        if (onTagSuccess) {
          onTagSuccess(taggedDocs, selectedTagsRef.current);
        }
      } catch (err) {
        console.error("❌ Tagging failed:", err);
      }
    }

    // Notify parent component
    if (typeof onUploadSuccess === "function") {
      onUploadSuccess();
    }

    // Reset state and close modal
    setFiles([]);
    setUploading(false);
    setUploadSuccess(false);
    setUploadErrors([]);
    setSelectedTags([]);

    onClose();
  };

  const handleAddMore = () => {
    handleClose();
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.click();
    }
  };

  // Check if all uploads are completed
  const allUploadsComplete = files.length > 0 && files.every(
    f => f.status === STATUS.SUCCESS || f.status === STATUS.ERROR
  );

  // Calculate success and error counts
  const successfulUploads = files.filter(f => f.status === STATUS.SUCCESS).length;
  const failedUploads = files.filter(f => f.status === STATUS.ERROR).length;

  // Set upload success when all complete and at least one success
  useEffect(() => {
    if (allUploadsComplete && successfulUploads > 0) {
      setUploadSuccess(true);
      setUploading(false);
    } else if (allUploadsComplete) {
      setUploading(false);
    }
  }, [allUploadsComplete, successfulUploads]);

  // Default icons if not provided
  const DefaultCloseIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  const DefaultCheckIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill={successColor}/>
    </svg>
  );

  const DefaultErrorIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill={errorColor}/>
    </svg>
  );
  
  const DefaultPlusIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M10 4.16669V15.8334M4.16669 10H15.8334" 
        stroke={uploadColor} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );

  const DefaultFileIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <mask id="mask0_775_15693" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_775_15693)">
        <path d="M7.5026 10.8307H12.5026C12.7387 10.8307 12.9366 10.7509 13.0964 10.5911C13.2561 10.4314 13.3359 10.2335 13.3359 9.9974C13.3359 9.76128 13.2561 9.56337 13.0964 9.40365C12.9366 9.24392 12.7387 9.16406 12.5026 9.16406H7.5026C7.26649 9.16406 7.06858 9.24392 6.90885 9.40365C6.74913 9.56337 6.66927 9.76128 6.66927 9.9974C6.66927 10.2335 6.74913 10.4314 6.90885 10.5911C7.06858 10.7509 7.26649 10.8307 7.5026 10.8307ZM7.5026 13.3307H12.5026C12.7387 13.3307 12.9366 13.2509 13.0964 13.0911C13.2561 12.9314 13.3359 12.7335 13.3359 12.4974C13.3359 12.2613 13.2561 12.0634 13.0964 11.9036C12.9366 11.7439 12.7387 11.6641 12.5026 11.6641H7.5026C7.26649 11.6641 7.06858 11.7439 6.90885 11.9036C6.74913 12.0634 6.66927 12.2613 6.66927 12.4974C6.66927 12.7335 6.74913 12.9314 6.90885 13.0911C7.06858 13.2509 7.26649 13.3307 7.5026 13.3307ZM7.5026 15.8307H10.0026C10.2387 15.8307 10.4366 15.7509 10.5964 15.5911C10.7561 15.4314 10.8359 15.2335 10.8359 14.9974C10.8359 14.7613 10.7561 14.5634 10.5964 14.4036C10.4366 14.2439 10.2387 14.1641 10.0026 14.1641H7.5026C7.26649 14.1641 7.06858 14.2439 6.90885 14.4036C6.74913 14.5634 6.66927 14.7613 6.66927 14.9974C6.66927 15.2335 6.74913 15.4314 6.90885 15.5911C7.06858 15.7509 7.26649 15.8307 7.5026 15.8307ZM5.0026 18.3307C4.54427 18.3307 4.15191 18.1675 3.82552 17.8411C3.49913 17.5148 3.33594 17.1224 3.33594 16.6641V3.33073C3.33594 2.8724 3.49913 2.48003 3.82552 2.15365C4.15191 1.82726 4.54427 1.66406 5.0026 1.66406H10.9818C11.204 1.66406 11.4158 1.70573 11.6172 1.78906C11.8186 1.8724 11.9957 1.99045 12.1484 2.14323L16.1901 6.1849C16.3429 6.33767 16.4609 6.51476 16.5443 6.71615C16.6276 6.91753 16.6693 7.12934 16.6693 7.35156V16.6641C16.6693 17.1224 16.5061 17.5148 16.1797 17.8411C15.8533 18.1675 15.4609 18.3307 15.0026 18.3307H5.0026ZM15.0026 7.4974H12.0859C11.7387 7.4974 11.4436 7.37587 11.2005 7.13281C10.9575 6.88976 10.8359 6.59462 10.8359 6.2474V3.33073H5.0026V16.6641H15.0026V7.4974Z" fill="#73607B"/>
      </g>
    </svg>
  );

  // Use custom icons or defaults
  const CloseIconComponent = CloseIcon || DefaultCloseIcon;
  const CheckIconComponent = CheckIcon || DefaultCheckIcon;
  const ErrorIconComponent = ErrorIcon || DefaultErrorIcon;
  const PlusIconComponent = PlusIcon || DefaultPlusIcon;
  const FileIconComponent = FileIcon || DefaultFileIcon;

  if (!isOpen) return null;

  const fileCount = filesToUpload.length;
  const pluralS = fileCount > 1 ? "s" : "";

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center font-outfit bg-black bg-opacity-40 backdrop-blur-sm ${modalClassName}`}>
      <div className={`relative w-full max-w-md p-6 bg-white rounded-lg shadow-xl mx-4 ${contentClassName}`}>
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
          aria-label="Close"
        >
          <CloseIconComponent />
        </button>

        {/* Header */}
        <div className="pr-8">
          <h2 className="text-xl font-semibold text-gray-800">
            {modalTitle}
          </h2>
         
        </div>

        {/* Error Messages */}
        {uploadErrors.length > 0 && (
          <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm font-medium text-red-800 mb-2">
              Some files failed to upload:
            </p>
            <ul className="text-sm text-red-700 list-disc list-inside space-y-1">
              {uploadErrors.map((error, index) => (
                <li key={index}>
                  <strong>{error.file}:</strong> {error.error}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Scrollable File List with Progress Bars */}
        <div className="mt-6 max-h-[200px] overflow-y-auto pr-2 space-y-4">
          {files.map((file, index) => (
            <div key={index} className="flex-shrink-0">
              {/* File name and progress/status */}
              <div className="flex items-center justify-between gap-3">
                <div className="flex min-w-0 flex-1 items-center gap-3">
                  <div className="flex-shrink-0">
                    <FileIconComponent />
                  </div>
                  <span className="truncate text-sm font-medium !text-[#171717]">
                    {file.file.name.length > 25
                      ? `${file.file.name.slice(0, 20)}...${file.file.name.slice(-10)}`
                      : file.file.name}
                  </span>
                </div>
                <div className="flex-shrink-0">
                  {file.status === STATUS.SUCCESS ? (
                    <CheckIconComponent />
                  ) : file.status === STATUS.ERROR ? (
                    <ErrorIconComponent />
                  ) : (
                    <span className="text-sm font-semibold text-gray-800">
                      {Math.round(file.progress)}%
                    </span>
                  )}
                </div>
              </div>
              
              {/* Progress bar */}
              <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-gray-200">
                <div
                  className={`h-2 rounded-full transition-all duration-300 ease-linear ${
                    file.status === STATUS.ERROR 
                      ? `bg-[${errorColor}]` 
                      : file.status === STATUS.SUCCESS 
                      ? `bg-[${successColor}]`
                      : `bg-[${uploadColor}]`
                  }`}
                  style={{
                    width: `${file.progress}%`,
                    background: file.status === STATUS.UPLOADING 
                      ? progressBarColor
                      : undefined,
                    backgroundColor: file.status === STATUS.UPLOADING 
                      ? undefined 
                      : file.status === STATUS.ERROR 
                      ? errorColor 
                      : file.status === STATUS.SUCCESS 
                      ? successColor 
                      : uploadColor,
                  }}
                ></div>
              </div>
              
              {file.status === STATUS.ERROR && (
                <p className="mt-1 text-xs text-red-600">
                  {file.errorReason === "unsupported"
                    ? "Unsupported file type"
                    : file.errorReason === "duplicate"
                    ? "Duplicate file"
                    : file.errorReason === "size_limit"
                    ? `File size exceeds ${maxFileSize} limit`
                    : "Upload failed"}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Footer */}
        {showAddMoreButton && (uploadSuccess || failedUploads > 0) && (
          <div className="mt-6 space-y-3">
            <button
              onClick={handleAddMore}
              className="flex items-center justify-center w-[30%] px-2 py-2 border !border-black/10 rounded-lg text-sm font-medium"
              style={{ color: uploadColor, borderColor: `${uploadColor}20` }}
            >
              <PlusIconComponent />
              <span className="ml-2" style={{ color: uploadColor }}>Add More</span>
            </button>
          </div>
        )}

        <div className="mt-6">
          {uploadSuccess || failedUploads > 0 ? (
            <div className="flex justify-end">
              <button
                onClick={handleClose}
                className="px-6 py-2.5 rounded-lg font-semibold text-sm"
                style={{ backgroundColor: uploadColor, color: "#fff" }}
              >
                Done
              </button>
            </div>
          ) : showSupportedFormats && (
            <div className="flex justify-between text-xs text-[#71717A]">
              <span>Supported formats: {supportedFormats}</span>
              <span>Maximum Size : {maxFileSize}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UploadModal;